<template >
    <div class="viewPlantas">
       
       <div class="btns-csv dflx">
                <p @click="setHistoryOptionCsv(!historyOption)" class="volver"><span>←</span> Volver</p>   <button @click="download(filename, info)" class="button-dw">Descargar <span>&#11123;</span></button>
       </div>
       
       <div class="tblplantas">
           <div class="hdr dflx">
               <p class="p1">Planta</p>
               <p class="p2">Departamento</p>
               <p class="p3">Meta</p>
               <p class="p4">Pago por excedente</p>
           </div>

           <div v-if="info.length >0">
               <div  class="items dflx">
                  <p class="p1 pvoid"></p>
               <p class="p2 pvoid"></p>
               <p class="p3 pvoid"></p>
               <p class="p4 pvoid"></p>
           </div>
           <div class="bodyitems">
               <div >
                   <div class="items  dflx" v-for="(item, key) in info" :key="key">
                    <p class="p1">{{item.planta}}</p>
                    <p class="p2">{{item.depto}}</p>
                    <p class="p3">{{item.meta}}</p>
                    <p class="p4">{{item.pago}}</p>
                    </div>
               </div>
           </div>
           
            <div class="items dflx">
                  <p class="p1 pvoid2"></p>
               <p class="p2 pvoid2"></p>
               <p class="p3 pvoid2"></p>
               <p class="p4 pvoid2"></p>
           </div>
           </div>
           <div v-else>
                <p class="cargando">Cargando...</p>
           </div>
           
       </div>
    
    </div>
</template>
<script>

import {mapActions} from 'vuex';
export default {
    name:'csvPlantasView',
    data(){
        return{
            filename: 'PLANTAS.csv',
        }
    },
    created() {
        this.getAllInfoCsv('get_info_plantas')
    },
    computed:{
        historyOption(){
                return this.$store.getters["csvplantas/getHistoryOption"]
         },
          info(){
                return this.$store.getters["csvplantas/data"]
         },
    },
    methods: {
           ...mapActions('csvplantas', ['setHistoryOptionCsv']),
            ...mapActions('csvplantas', ['getAllInfoCsv']),

             download: function(filename, rows) { 
            this.$store.commit('admin/DOWNLOADING', 'Descargando...');                
            let newArr = [];            
            rows.forEach(item => {
                let tempArr = [];
                tempArr.push(item.planta);
                tempArr.push(item.depto);
                tempArr.push(item.meta);    
                 tempArr.push(item.pago);     
                newArr.push(tempArr);
            });

            let csvFile = '';
            let arrlen = newArr.length;
            for (let i = 0; i < arrlen; i++) {        
                csvFile += this.processRow(newArr[i]);
            }
            this.blob(filename, csvFile)
        },
        processRow: function (row) {
            let finalValue = '';
            let rowlen = row.length;

            for (let j = 0; j < rowlen; j++) {
                let innerValue = row[j] === null ? '' : row[j].toString();
                let result = innerValue.replace(/"/g, '""');
                if (result.search(/("|,|\n)/g) >= 0){ result = '"' + result + '"'; }
                if (j > 0){ finalValue += ',';}

                finalValue += result;
            }
            return finalValue + '\n';
        },
        blob: function (filename, csvFile){
            let blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                let link = document.createElement("a");
                if (link.download !== undefined) {
                    let url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.click();
                }
            }
           
        }

    }
}
</script>
<style scoped>

.viewPlantas{
    padding: 1.5vw;
}
        .dflx{
            display: flex;

        }

        button.button-dw{
            background: #ECF0F7;
            margin-left: 71%;
            border: 1px solid #5981E8;
            color: #5981E8;
            border-radius: .5vw .5vw .5vw .5vw;
            width: 7vw;
            font-size:.6vw;
        }
         button.button-dw span{
           font-size:.9vw;
           margin-left: .5vw;
           padding-top: .3vw;
           font-weight: 900;
        }

        p.volver{
            color: #838383;
           
            font-size: .8vw;
        }
        p.volver span{
            font-size: 1vw;
            font-weight: 900;
        }

.tblplantas{
    margin-top: 1vw;
}
        .hdr p{
            text-transform: uppercase;
            background: #4D78E7;
            color: #F7F9FE;
            text-align: center;
            font-size: .6vw;
             margin-bottom: 0vw;
             padding-top: 1vw;
              padding-bottom: 1vw;
              border-right: 1px solid #FFFFFF;
              
        }

        .items p{
           
           margin-bottom: 0vw;
             color: #838383;
           padding-bottom: .4vw;
            text-align: center;
            font-size: .7vw;
        }

        .items p.p1, .items p.p3{
             background: #FFFFFF;
        }

        .items p.p2, .items p.p4{
             background: #F8F8F8;
        }

        p.p1{
            width: 8vw;
        }
        p.p2{
            width: 11vw;
        }
        p.p3{
            width: 7vw;
        }
        p.p4{
            width: 12vw;
        }
        p.pvoid2, p.pvoid{
            height: 2vw;
        }
        .bodyitems{
            max-height: 30vw;
            overflow: auto;
        }

        p.pvoid2:first-child{
            border-radius: 0vw 0vw 0vw .4vw;
        }
         p.pvoid2:last-child{
            border-radius: 0vw 0vw .4vw .0vw;
        }

        .hdr p:last-child{
            border-radius: 0vw .4vw 0vw 0vw ;
            border: none;
        }
         .hdr p:first-child{
            border-radius:  .4vw .0vw 0vw 0vw;

        }

        p.cargando{
            color: #838383;
            font-style: italic;
            font-size: .9vw;
            text-align: center;
            padding: 1vw;
        }
</style>